import src from "IMAGE";
export default { src, width: 546, height: 295, blurWidth: 0, blurHeight: 0};
